/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	footer: {
		borderTopWidth: token('border.width.selected'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
		paddingTop: token('space.050'),
		paddingBottom: token('space.050'),
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
});

export const Footer = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.footer} {...props}>
		{children}
	</div>
);
